import * as mutation from "./mutation-types";
import * as action from "./action-types";
import { tableHelper } from "@/helpers/table.helper";
import { deepCopyAxiosException } from "@/store/helpers";
import axios from "axios";
import { GLOBAL_ERROR } from "@/store/system/mutation-types";

export const actions = {
  async [action.LIST]({ commit, state }) {
    commit(mutation.LIST_STARTED);
    try {
      const url = tableHelper.constructUrl("/api/exception-logs", state.listing.paging, state.listing.criteria);
      const { headers, data } = await axios.get(url);
      commit(mutation.LIST_SET_CRITERIA_DESCRIPTION, tableHelper.getCriteriaInfo(headers));
      commit(mutation.LIST_SET_PAGING, tableHelper.getPagingFromHeaders(headers));
      commit(mutation.LIST_SUCCEEDED, data);
      return true;
    } catch (e) {
      commit(mutation.LIST_FAILED);
      commit(GLOBAL_ERROR, deepCopyAxiosException(e));
      return false;
    }
  },
  async [action.LIST_NEXT_PAGE]({ state, commit, dispatch }) {
    commit(mutation.LIST_SET_PAGING, { page: state.listing.paging.page + 1 });
    await dispatch(action.LIST);
  },
  async [action.LIST_PREVIOUS_PAGE]({ state, commit, dispatch }) {
    commit(mutation.LIST_SET_PAGING, { page: state.listing.paging.page - 1 });
    await dispatch(action.LIST);
  },

  async [action.EXPORT]({ commit, state }) {
    commit(mutation.EXPORT_STARTED);
    try {
      await axios.get(tableHelper.constructUrl("/api/exports/validate/exception-logs", state.listing.criteria));
      const url = tableHelper.constructUrl("/api/exports/exception-logs", state.listing.criteria);
      tableHelper.downloadExportedSpreadsheet(url);
      commit(mutation.EXPORT_SUCCEEDED);
      return true;
    } catch (e) {
      commit(mutation.EXPORT_FAILED);
      commit(GLOBAL_ERROR, deepCopyAxiosException(e));
      return false;
    }
  },

  async [action.VIEW]({ commit, state }, id) {
    commit(mutation.VIEW_STARTED, id);
    try {
      const url = `/api/exception-logs/${id}`;
      const { data } = await axios.get(url);
      commit(mutation.VIEW_SUCCEEDED, data);
      const index = tableHelper.getIndexOfId(state.listing, state.view.data.id);
      commit(mutation.VIEW_NEXT, tableHelper.getNextRecordInfo(index, state.listing));
      commit(mutation.VIEW_PREVIOUS, tableHelper.getPreviousRecordInfo(index, state.listing));
      return true;
    } catch (e) {
      commit(mutation.VIEW_FAILED);
      commit(GLOBAL_ERROR, deepCopyAxiosException(e));
      return false;
    }
  },
  async [action.THROW_EXCEPTION]({ commit }) {
    commit(mutation.THROW_STARTED);
    try {
      await axios.post("/api/system-diagnostics/exceptions");
      return true;
    } catch (e) {
      commit(mutation.THROW_SUCCEEDED);
      commit(GLOBAL_ERROR, deepCopyAxiosException(e));
      commit(mutation.STATE_UNLOAD);
      return false;
    }
  },
  async [action.STATS_FOR_WEEK]({ commit }) {
    commit(mutation.STATS_FOR_WEEK_STARTED);
    try {
      const { data } = await axios.get("/api/exception-logs/statistics/errors-over-last-week");
      commit(mutation.STATS_FOR_WEEK_SUCCEEDED, data);
    } catch (e) {
      commit(mutation.STATS_FOR_WEEK_FAILED);
      commit(GLOBAL_ERROR, deepCopyAxiosException(e));
    }
  },

  async [action.STATS_BY_MONTH]({ commit }) {
    commit(mutation.STATS_BY_MONTH_STARTED);
    try {
      const { data } = await axios.get("/api/exception-logs/statistics/counts-by-month");
      commit(mutation.STATS_BY_MONTH_SUCCEEDED, data);
    } catch (e) {
      commit(mutation.STATS_BY_MONTH_FAILED);
      commit(GLOBAL_ERROR, deepCopyAxiosException(e));
    }
  },

  async [action.CONNECTIVITY]({ commit }) {
    commit(mutation.CONNECTIVITY_STARTED);
    try {
      const { data } = await axios.get("/api/exception-logs/statistics/connectivity");
      commit(mutation.CONNECTIVITY_SUCCEEDED, data);
    } catch (e) {
      commit(mutation.CONNECTIVITY_FAILED);
      commit(GLOBAL_ERROR, deepCopyAxiosException(e));
    }
  }
};
